/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'pip-model',
  'velocity',
  'plugin.tooltip',
  'pip-common.utils',
],
  function proReferralAddOn(
    $,
    Mustache,
    pip,
    velocity,
    tooltip,
    utils
  ) {

    var elements = {
      optInCheckbox: '#pro-referral__checkbox',
      whatToExpect: '.buybox__pro-referral .buybox__add-on__learn-more-cta',
      addOnContainer: '#add-on__container'
    };

    var templates = {
      default: {
        addOn: $('#pro-referral-add-on-template').html(),
        multiAddOn: $('#pro-referral-multi-add-on-template').html(),
        tooltip: $('#pro-referral-tooltip-template').html(),
      },
      painter: {
        addOn: $('#pro-referral--paint-add-on-template').html(),
        multiAddOn: $('#pro-referral--paint-multi-add-on-template').html(),
        tooltip: $('#pro-referral--paint-tooltip-template').html()
      }
    };

    var activeTemplates = templates.default;

    function isProReferralAddOnDisplayable() {
      return !pip.isB2BCustomer && pip.serviceAddOns && pip.serviceAddOns.proReferral && !pip.serviceAddOns.proReferral.isAtHomeAssembly
    }

    function initEventListeners() {
      var tooltipOptions = {
        type: 'click',
        position: 'bottom',
        content: activeTemplates.tooltip,
        width: utils.getTooltipSize(),
        closeButton: true,
        bestPosition: false,
        closeOnClick: true
      };
      $(elements.whatToExpect).tooltip(tooltipOptions);

      $(document).off('.pro-referral');
      $(document).on('change.pro-referral', elements.optInCheckbox, function () {
        var tooltipState = $(this).is(':checked') ? 'open' : 'close';
        $(elements.whatToExpect).tooltip(tooltipState);
        pip.customer.isOptedIntoProReferral = $(this).is(':checked');
      });
    }

    return {
      init: function init(addOns) {

        if (!isProReferralAddOnDisplayable()) return;

        if (pip.serviceAddOns.proReferral.category === 'Painter') {
          activeTemplates = templates.painter;
        }
        var template = activeTemplates.addOn;
        var container = elements.addOnContainer;

        if (addOns && addOns.multipleAddOns && addOns.side) {
          template = activeTemplates.multiAddOn;
          container = '#multi-add-on-' + addOns.side;
        }

        $(container).html(Mustache.render(template)).velocity('slideDown', { duration: 300 });
        initEventListeners();
      },

      isProReferralAddOnDisplayable: isProReferralAddOnDisplayable
    }
  });

}.call(window));